<template>
  <v-layout row wrap fill-height>
    <Loader v-if="loading" skin="light"></Loader>
    <v-flex v-else xs12>
      <v-layout row wrap fill-height>
        <v-navigation-drawer
          persistent
          v-model="nav_drawer"
          enable-resize-watcher
          permanent
          style="z-index: 2"
        >
          <v-list>
            <template v-for="enum_item in enums_list">
              <v-list-tile @click="activeTab=enum_item.page" :color="activeTab==enum_item.page ? 'indigo darken-1' : ''">
                <v-list-tile-action>
                  <v-icon :color="activeTab==enum_item.page ? 'indigo darken-1' : ''">filter_list</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{ enum_item.name }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
          </v-list>
        </v-navigation-drawer>
        <v-content class="pa-2">

        </v-content>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>

import CiselnikBasic from './CiselnikyPages/CiselnikBasic'

export default {
  data: function() {
    return {
      loading: true,
      activeTab: "pojistovny",
      nav_drawer: true,
      enums_list: [
        { name: "Pojištovny", page: "pojistovny" },
        { name: "Stavy PU", page: "stavy_pu" },
        { name: "Stavy prohlídek", page: "stavy_prohlidek" },
        { name: "Události", page: "udalosti_pu" },
        { name: "Typy ohlašovatelů", page: "typy_ohlasovatelu" },
        { name: "Způsoby plateb", page: "zpusoby_platby" },
        { name: "Stavy plateb", page: "stavy_plateb" },
        { name: "Typy úkolů", page: "typy_ukolu" },
        { name: "Měny", page: "meny" },
        { name: "Sady dokumentů", page: "sady_dokumentu" },
      ],
      udalost: null,
      pricina: null,
      priciny: [],
      fotodokumentace: [],
      fotodokumentace_skupina: null,
      enums_data: {
        pojistovny: [],
        stavy_pu: [],
        udalosti_pu: [],
        typy_ohlasovatelu: [],
        stavy_plateb: [],
        meny: [],
        sada_dokumentu: null,
        dokumenty: []
      }
    }
  },
  props: {
    tab: String
  },
  watch: {
    activeTab (val) {
      //this.$router.replace({ path: "/nastaveni/ciselniky/"+val })
      //this.enums_list.filter(function(e) { return e.page == val; })[0]
    }
  },
  mounted: function() {
    //this.load();
  },
  methods: {
    load: function() {
      window.api.get("ciselniky").then(function($r) {
        this.enums_data = $r;
        this.loading = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    udalostclick: function(id) {
      this.udalost = this.enums_data.udalosti_pu.filter(x => x.id == id)[0];
      this.priciny = this.enums_data.udalosti_pu.filter(x => x.id == id)[0].priciny;
      this.activeTab = "priciny";
    },
    pricinaclick: function(id) {
      this.pricina = this.udalost.priciny.filter(x => x.id == id)[0]
      this.podpriciny = this.udalost.priciny.filter(x => x.id == id)[0].podpriciny;
      this.activeTab = "podpriciny";
    },
    sadadokumentuclick: function(id) {
      this.sada_dokumentu = this.enums_data.sady_dokumentu.filter(x => x.id == id)[0];
      this.dokumenty = this.enums_data.sady_dokumentu.filter(x => x.id == id)[0].dokumenty;
      this.activeTab = "sady_dokumentu_dokumenty";
    },
    photosetsclick: function(udalost_pu) {
      this.udalost = udalost_pu;
      this.fotodokumentace = this.udalost.fotodokumentace;
      this.activeTab = "sady_fotodokumentaci_skupiny";
    },
    photosetclick: function($skupina) {
      this.fotodokumentace_skupina = $skupina;
      this.activeTab = "sady_fotodokumentaci_skupiny_fotky";
    },
    gotoalldocumentsets: function() {
      this.sada_dokumentu = null;
      this.dokumenty = null;
      this.activeTab = "sady_dokumentu";
    },
    gotoallevents: function() {
      this.udalost = null;
      this.priciny = null;
      this.podpriciny = null;
      this.activeTab = "udalosti_pu";
    },
    gotoevent: function() {
      this.podpriciny = null;
      this.activeTab = "priciny";
    },
    gotophotosets: function() {
      this.fotodokumentace_skupina = null;
      this.activeTab = "sady_fotodokumentaci_skupiny";
    }
  },
  components: {
    CiselnikBasic
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Nastaveni/Ciselniky.vue